import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import LoginForm from '../../components/public/LoginForm.component';
import { PUBLIC_AUTHENTICATION_APP_PATHS } from '../../constants/authentication-paths.constants';
import { PUBLIC_PANELS } from '../../../shared/public/constants/panel.constants';
import { BASE_PUBLIC_V2_PATH } from '../../../shared/public/constants/path.constants';

const PANEL_ROUTES: Record<string, string> = {
  [PUBLIC_PANELS.SIGNUP]: PUBLIC_AUTHENTICATION_APP_PATHS.SIGNUP,
  [PUBLIC_PANELS.FORGOT_PASSWORD]: PUBLIC_AUTHENTICATION_APP_PATHS.FORGOT_PASSWORD,
};

const useStyles = makeStyles((theme) => ({
  wrapper: { display: 'flex', justifyContent: 'center', padding: theme.spacing(6, 3) },
  column: { width: '100%', maxWidth: 440 },
  title: {
    fontFamily: 'Bitter, serif',
    fontWeight: 700,
    marginBottom: theme.spacing(3),
    color: theme.palette.client.primary.extraDark,
  },
}));

const LoginView: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();

  const onSuccess = () => history.push(BASE_PUBLIC_V2_PATH);
  const onNavigate = (panel: string) => history.push(PANEL_ROUTES[panel] ?? PUBLIC_AUTHENTICATION_APP_PATHS.LOGIN);

  return (
    <React.Fragment>
      <Helmet>
        <title>Connexion - Bio Culture</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className={classes.wrapper}>
        <div className={classes.column}>
          <Typography variant="h4" component="h1" className={classes.title}>
            Connexion
          </Typography>

          <LoginForm onSuccess={onSuccess} onNavigate={onNavigate} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default LoginView;
